import { AppPresence, GuestProfile, LimitedAgentProfile } from "@closerplatform/spinner-openapi";
import { apiActions } from "..";
import { observable } from "mobx";
import { UserProfile } from "@fidget/common/models/userProfile";
import { AbstractUserService, IUserService } from "@fidget/common/services/userService";
import { ForeStore } from "../store/main";
import { ForeSpinnerService } from "./spinnerService";

export class UserService extends AbstractUserService implements IUserService {
  private botPlaceholder = (id: string): LimitedAgentProfile =>
    observable({
      firstName: "",
      lastName: "",
      isActive: true,
      isBot: true,
      presence: AppPresence.Unavailable,
      id
    });

  get state() {
    return this.foreStore.state.shared;
  }

  constructor(private readonly foreStore: ForeStore) {
    super();
  }

  // XXX: Temporary solution till mst won't be implemented in widget
  getAgent(id: string) {
    const agent = this.state.agents.get(id);
    const spinner = ForeSpinnerService.getInstance();
    if (!agent) {
      let placeholder: LimitedAgentProfile = observable({
        firstName: "Unknown",
        lastName: "lim",
        isActive: true,
        isBot: false,
        presence: AppPresence.Unavailable,
        id
      });
      apiActions.agentProfilesLoaded(this.state, [placeholder]);
      spinner.getAgentProfile(id).then((profile) => {
        apiActions.agentProfileUpdated(this.state, profile);
        // fixme: current user store is not adapted to handle async flow, so this is needed until refactor
        this.foreStore.state.profileLoadedCounter++;
      });
      return placeholder;
    }
    return agent;
  }

  getGuest(id: string) {
    const currentUser = this.getCurrentUser();
    return currentUser.id === id ? (currentUser as GuestProfile) : undefined;
  }

  getCurrentUser(): UserProfile {
    return this.foreStore.state.profile!;
  }

  getBotProfile() {
    const orgId = this.state.org.id;

    const botProfile = this.state.agents.get(orgId);
    if (botProfile) {
      return botProfile;
    }

    const botPlaceholder = this.botPlaceholder(orgId);
    apiActions.agentProfileUpdated(this.state, botPlaceholder);

    return botPlaceholder;
  }

  protected getBotProfileId() {
    const botAgent = Object.values(this.state.agents).find((agent) => agent.isBot);
    return botAgent && botAgent.id;
  }
}
